/**
 * Colores de terreno para hornear minimapas (editor y juego).
 *
 * Fuente única de verdad de los colores por familia de sprite. Tanto el minimapa del
 * editor (`MapOverlay`) como el minimapa in-game (`Minimap`) usan `minimapColorFor` para
 * que el terreno se vea consistente en ambos.
 */

export const MINIMAP_COLOR_BG = 0x000000; // fondo = mismo que el mundo del juego
export const MINIMAP_COLOR_BLOCKED = 0x222222; // tiles bloqueados sin sprite (paredes invisibles)
// Colores por familia de sprite.
export const MINIMAP_COLOR_GRASS = 0x5a8f3c;
export const MINIMAP_COLOR_SAND = 0xd9c184;
export const MINIMAP_COLOR_SNOW = 0xe8eef2;
export const MINIMAP_COLOR_PATH = 0x9c7a4d;
export const MINIMAP_COLOR_DUNGEON = 0x4a4750; // piedra oscura (pattern7 = dungeon1)
export const MINIMAP_COLOR_WATER = 0x3a6ea5;
export const MINIMAP_COLOR_TREE = 0x163d16;
export const MINIMAP_COLOR_ENTRANCE = 0x8e44ad;

/**
 * Color del minimapa para un sprite de tile, o `null` si el tile no se pinta (transparente).
 * `blocked` pinta gris oscuro los tiles bloqueados sin sprite (paredes invisibles).
 */
export function minimapColorFor(sprite: string | undefined, blocked: boolean): number | null {
  if (!sprite) {
    return blocked ? MINIMAP_COLOR_BLOCKED : null;
  }
  if (sprite.startsWith('tree') || sprite.startsWith('decoration')) return MINIMAP_COLOR_TREE;
  if (sprite.startsWith('entrance')) return MINIMAP_COLOR_ENTRANCE;
  if (sprite.startsWith('pattern2')) return MINIMAP_COLOR_GRASS;
  if (sprite.startsWith('pattern4')) return MINIMAP_COLOR_SAND;
  if (sprite.startsWith('pattern6')) return MINIMAP_COLOR_SNOW;
  if (sprite.startsWith('pattern5')) return MINIMAP_COLOR_PATH;
  if (sprite.startsWith('pattern7') || sprite.startsWith('pattern3')) return MINIMAP_COLOR_DUNGEON; // dungeon1/2
  if (sprite.includes('water')) return MINIMAP_COLOR_WATER;
  return blocked ? MINIMAP_COLOR_BLOCKED : null;
}
